import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, TextField, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useMemo, useRef, useState } from 'react'
import { Icons, latexDelimiters } from '../../utils/utilities'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import ReactQuill from 'react-quill'
import CustomSwitch from '../common/CustomSwitch'
// import { useQuizAndQuestionbankStore } from '../../store/quizandquestionbank.store'
import { observer } from 'mobx-react'
import Latex from 'react-latex-next'
import { toast } from 'react-toastify'
import api from '../../service/api'
import { useParams } from 'react-router-dom'
import { useAdmissionExamStore } from '../../store/admission-exam.store'
import CustomChip from '../common/CustomChip'

const modules = {
    toolbar: {
        container: [
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ size: ['normal', 'small', 'large'] }],
            [{ align: [] }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
            ['clean'],
            ['code-block'],
        ],
        // handlers: {
        //     image: async () => await handleFileInput( 'image' ),
        //     video: async () => await handleFileInput( 'video' ),
        // },
    },
}



const validationSchema = Yup.object().shape( {
    question: Yup.string().required( "Question is required!" ),
    marks: Yup.number().required( "Marks is required." ).test( "VALID_MARKS", "Enter a valid marks", ( val, { parent } ) => {
        if ( val && !isNaN( parseInt( val ) ) && parseInt( val ) > 0 )
            return true
        return false
    } ),
    options: Yup.mixed().required( "Options are required" ).test( "MINIMUM_TWO_OPTIONS", "A question should has minimum of 2 options.", ( val ) => {
        if ( val.length > 1 )
            return true
        return false
    } ),
    answersStatus: Yup.mixed().test( "ATLEAST_TWO_CORRECT_ANSWERS", "Please select at least two correct answers.", ( val, { parent } ) => {
        if ( parent.selectionType === "single" ) return true
        if ( val.filter( i => i === true ).length >= 2 )
            return true
        return false
    } ),
    correctAnswer: Yup.number().test( "CORRECT_ANSWER", "Please select a correct answer.", ( val, { parent } ) => {
        if ( parent.selectionType !== "single" ) return true
        if ( val >= 0 && val < parent.options.length )
            return true
        return false
    } ),
} )

const OptionComponent = ( { getQuestions, setFieldValue, removeOption, option, optionIndex, values, handleCorrectAnswerChange, selectedLanguage } ) => {

    const [saving, setSaving] = useState( false )
    const [editMode, setEditMode] = useState( false )
    const [optionPlainText, setOptionPlainText] = useState()
    const [editValue, setEditValue] = useState( option.answer_text )
    const [currentSavedOptionTextValue, setCurrentSavedOptionTextValue] = useState( option.answer_text )

    const { id } = useParams()

    const hadleOptionValueChange = ( val, d, u, e ) => {
        setOptionPlainText( e?.getText()?.trim() )
        setEditValue( val )
    }

    const updateOptionText = async () => {
        setSaving( true )
        try {
            if ( optionPlainText && option?.answer_id ) {
                const payload = {
                    answer_text: editValue,
                    translationLanguageUpdate: Boolean( option?.translations?.[selectedLanguage] ),
                    language: selectedLanguage
                }
                const { data } = await api.admissionExams.updateOptionText( id, option?.answer_id, payload )
                toast( data?.message || "Option saved successfully!" )
                setCurrentSavedOptionTextValue( editValue )
                await getQuestions()
                setEditMode( false )
            }
        } catch ( err ) {
            toast( err?.response?.data?.message || "Couldn't save changes! try again." )
        } finally {
            setSaving( false )
        }
    }

    const { palette, shadows, border } = useTheme()

    const remove = () => {
        setEditMode( false )
        removeOption( optionIndex, values, setFieldValue )
    }

    return (
        <Box borderRadius="5px" sx={{ transition: "ease 200ms" }} marginY={editMode ? "10px" : "0"} marginX={editMode ? "-5px" : ""} padding={editMode ? "5px" : "0"} overflow="hidden" boxShadow={editMode ? shadows[5] : "none"} border={border[1]} borderColor={editMode ? palette.secondary.light : ""} >
            <Box marginBottom="2px" display="flex" gap="5px" alignItems="center">
                {!editMode && <Tooltip placement='right' title={( optionIndex === values.correctAnswer ) ? values.selectionType === "single" ? "Marked as correct" : "mark as incorrect" : "Mark as correct answer"}>
                    <span>
                        {values.selectionType !== "single" && <Checkbox onChange={( e ) => handleCorrectAnswerChange( optionIndex, values, e.target.checked, setFieldValue )} size='small' color="success" checked={values.answersStatus[optionIndex] || false} />}
                        {values.selectionType === "single" && <Radio onChange={( e ) => handleCorrectAnswerChange( optionIndex, values, e.target.checked, setFieldValue )} size='small' color="success" checked={optionIndex === values.correctAnswer} />}
                    </span>
                </Tooltip>}
                {editMode && <Typography paddingLeft="10px" fontWeight="500" fontSize="15px">Edit option</Typography>}

                {!editMode && <Box flexGrow={1} className='wysiwyg-text-container' borderRadius="10px">
                    <Latex delimiters={latexDelimiters} >{currentSavedOptionTextValue}</Latex>
                </Box>}
                <Box display="flex" flexGrow={1} justifyContent="flex-end" gap="20px">
                    {!editMode && option?.answer_id && <IconButton size="small" color="secondary" onClick={() => setEditMode( prev => !prev )}>{Icons.small.EditIcon}</IconButton>}
                    {editMode && <Button size="small" startIcon={Icons.small.CloseIcon} sx={{ textTransform: "capitalize" }} color="errorMessage" onClick={() => setEditMode( prev => !prev )}>Cancel edit</Button>}
                    {!editMode && <Tooltip title="Remove option">
                        <IconButton size="small" color="errorMessage.main" onClick={remove}>{Icons.default.RemoveIcon}</IconButton>
                    </Tooltip>}
                    {editMode && <Button size="small" startIcon={Icons.default.RemoveIcon} sx={{ textTransform: "capitalize" }} color="greyed" onClick={remove}>Remove option</Button>}
                </Box>
            </Box>
            {editMode && <Box padding="5px" bgcolor={palette.form.inputBg} color={palette.common.font} >
                <ReactQuill placeholder='Type the option text here...' className='custom-quill' modules={modules} value={editValue} onChange={hadleOptionValueChange} />
                <Button disabled={saving || optionPlainText === ''} startIcon={saving && <CircularProgress size={14} />} onClick={updateOptionText} sx={{ textTransform: "capitalize", marginTop: "10px" }} size='small' color="success" variant='contained' disableElevation >Save</Button>
            </Box>}
        </Box>
    )
}

const EditForm = ( { handleClose, selectedLanguage, hasOptionsChangedRef, question, getQuestions } ) => {

    const [optionAdderSwitchState, setOptionAdderSwitchState] = useState( false )
    const [optionAddedFieldValue, setOptionAddedFieldValue] = useState( "" )
    const [saving, setSaving] = useState( false )

    const { palette, border } = useTheme()
    const { id } = useParams()

    const initialValues = useMemo( () => {

        const questionText = question?.translations?.[selectedLanguage] || question.question_text
        const finalOptions = []

        for ( const option of question.options ) {
            const optionsDetails = {}
            optionsDetails.answer_id = option.answer_id
            optionsDetails.answer_text = option?.translations?.[selectedLanguage] || option.answer_text
            optionsDetails.answer_status = option.answer_status
            optionsDetails.question_id = option.question_id
            optionsDetails.translations = option.translations

            finalOptions.push( optionsDetails )
        }


        return {
            question: questionText,
            marks: question.marks,
            questionType: question.question_type,
            selectionType: question.selection_type,
            options: finalOptions,
            answersStatus: question.options_status,
            correctAnswer: question.question_type === 'MCQ' ? question.selection_type === 'single' ? question.correct_answer || question.options_status?.indexOf( true ) : '' : question.options[0],
            section: question.question_section,
        }

    }, [question, selectedLanguage] )


    const handleEditorValueChange = ( val, setValue, prevVal ) => {
        setValue( 'question', val )
    }

    const retriveOldOptions = ( setValue ) => {
        setValue( 'options', initialValues.options )
        setValue( 'correctAnswer', initialValues.correctAnswer )
        setValue( 'answersStatus', initialValues.answersStatus )
    }

    const handleCorrectAnswerChange = ( index, values, val, setValue ) => {
        if ( values.selectionType === 'single' ) {

            const options = [...values.options]
            options.forEach( option => {
                option.answer_status = 0
            } )
            options[index].answer_status = val

            let newStatus = [...values.answersStatus]
            newStatus[index] = val


            setValue( 'answersStatus', newStatus )
            setValue( 'correctAnswer', index )
            setValue( 'options', options )
        } else {
            let newStatus = [...values.answersStatus]
            newStatus[index] = val
            const options = [...values.options]
            options.forEach( option => {
                option.answer_status = 0
            } )
            options[index].answer_status = 1

            setValue( 'answersStatus', newStatus )
            setValue( 'options', options )
        }
    }

    const addOption = ( options, correctAnswers, type, setValue ) => {
        if ( optionAddedFieldValue && ( optionAddedFieldValue?.trim() !== "" && optionAddedFieldValue?.trim() !== "<p><br/></p>" && optionAddedFieldValue?.trim() !== "<p></p><br/>" && optionAddedFieldValue?.trim() !== "<p><br></p>" ) ) {

            let translations = null
            if ( question?.translations ) {
                const languages = Object.keys( question?.translations )
                translations = {}
                for ( const lang of languages ) {
                    if ( !question.translations[lang] ) {
                        translations[lang] = null
                    } else {
                        translations[lang] = optionAddedFieldValue
                    }
                }
            }
            const newOptions = [...options, { answer_text: optionAddedFieldValue, translations }]
            if ( type === 'single' && optionAdderSwitchState ) {
                setValue( 'correctAnswer', newOptions.length - 1 )
            }
            const newStatuses = [...correctAnswers, optionAdderSwitchState]
            setValue( 'answersStatus', newStatuses )

            setValue( 'options', newOptions )
            setOptionAddedFieldValue( "<p></p><br/>" )
            setOptionAdderSwitchState( false )
        }
    }

    const removeOption = ( index, values, setValue ) => {
        let newOptions = [...values.options]
        let newStatus = [...values.answersStatus]
        newStatus.splice( index, 1 )
        newOptions.splice( index, 1 )
        setValue( 'answersStatus', newStatus )
        setValue( 'options', newOptions )
        if ( values.correctAnswer === index )
            setValue( 'correctAnswer', "" )
    }

    const editQuestion = async ( values ) => {
        setSaving( true )
        try {
            values.hasOptionsChanged = Boolean( hasOptionsChangedRef.current )
            values.translationLanguageUpdate = Boolean( question?.translations?.[selectedLanguage] )
            values.language = selectedLanguage
            values.originalValues = question.options
            console.log( values )

            if ( values.hasOptionsChanged ) {
                if (
                    question.correctAnswer !== values.correctAnswer ||
                    !( question.answersStatus?.length === values.answersStatus.length &&
                        question.answersStatus.every( ( val, index ) => val === values.answersStatus[index] )
                    )
                ) {
                    values.correctAnswerUpdated = true
                } else
                    values.correctAnswerUpdated = false
            } else
                values.correctAnswerUpdated = false


            const { data } = await api.admissionExams.updateQuestion( id, question.question_id, values )
            toast( data?.message || "Question saved successfully!" )
            handleClose()
        } catch ( err ) {
            toast( err?.response?.data?.message || "Couldn't save changes! try again." )
        } finally {
            setSaving( false )
        }
    }


    return (
        <Formik onSubmit={editQuestion} initialValues={initialValues} validationSchema={validationSchema}>
            {( { values, setFieldValue, resetForm } ) => {

                let optionsChanged = false
                if ( question.options?.length !== values.options.length ) {
                    optionsChanged = true
                } else {

                    const originalOptionIds = new Set( question.options?.map( op => op.answer_id ) )
                    const currentOptionsIds = new Set( values.options.map( op => op.answer_id ) )

                    const diff = originalOptionIds.symmetricDifference( currentOptionsIds )
                    optionsChanged = diff.size > 0

                    if ( !optionsChanged ) {
                        if ( values.correctAnswer !== initialValues.correctAnswer ) {
                            optionsChanged = true
                        }
                    }
                }
                hasOptionsChangedRef.current = optionsChanged

                return (
                    <Box>
                        <Form>
                            <Box border={border[1]} padding="20px" borderRadius="5px" bgcolor={palette.contentBg} >


                                <FormControl margin="dense" fullWidth>
                                    <Typography variant='subtitle2' color={palette.labelColor}>
                                        Question Section
                                    </Typography>
                                    <Field disabled={true} fullWidth size="small" as={TextField} name="section" value={values.section} />
                                    <Typography fontSize="12px" color='errorMessage.main'><ErrorMessage name='section' /></Typography>
                                </FormControl>
                                <FormControl margin="dense" fullWidth>
                                    <Typography variant='subtitle2' color={palette.labelColor} gutterBottom>Question Text *</Typography>
                                    <Box bgcolor={palette.form.inputBg}>

                                        <ReactQuill
                                            className='custom-quill'
                                            modules={modules}
                                            placeholder={'Type here...'}
                                            value={values.question?.replace( /$/g, "" )}
                                            onChange={val =>
                                                handleEditorValueChange( val, setFieldValue, values.question )
                                            }
                                        />
                                        <Typography fontSize="12px" color='textSecondary'>To Add mathematical formula, use latex, Eg: <strong> <em>${"{LATEX}"}$</em> </strong></Typography>
                                        {/* {values.question?.match( /\$/ ) && <Box marginTop="10px" className='wysiwyg-text-container' padding="10px" border={border[1]} borderRadius="10px">
                                                    <Latex delimiters={latexDelimiters} >{values.question}</Latex>
                                                </Box>} */}

                                    </Box>
                                    <Typography fontSize="12px" color='errorMessage.main'>
                                        <ErrorMessage name='question' />{' '}
                                    </Typography>
                                </FormControl>
                                <FormControl margin="dense" fullWidth>
                                    <Typography variant='subtitle2' color={palette.labelColor} gutterBottom>Question marks *</Typography>
                                    <Field size="small" as={TextField} placeholder="Specify question's points" type="number" name="marks" onWheel={e => { e.target.blur() }} />
                                    <Typography fontSize="12px" color='errorMessage.main'><ErrorMessage name='marks' />{' '}</Typography>
                                </FormControl>
                                {values.options.length > 0 && <Box>
                                    <Box display="flex" gap="20px" marginTop="20px" marginBottom="5px" alignItems="center" color="secondary">
                                        <Typography gutterBottom sx={{ color: palette.labelColor }} variant="subtitle2">Options</Typography>
                                        {optionsChanged && <Button startIcon={Icons.default.Reply} onClick={() => retriveOldOptions( setFieldValue )} sx={{ textTransform: "capitalize" }} >Retrive old options</Button>}
                                    </Box>
                                    <Box display="flex" flexDirection="column" gap="2px">
                                        {values.options.map( ( option, optionIndex ) => (
                                            <OptionComponent
                                                getQuestions={getQuestions}
                                                selectedLanguage={selectedLanguage}
                                                setFieldValue={setFieldValue}
                                                removeOption={removeOption} option={option} values={values} key={optionIndex} optionIndex={optionIndex} handleCorrectAnswerChange={handleCorrectAnswerChange} />
                                        ) )}
                                    </Box>
                                </Box>}
                                <Typography fontSize="12px" color='errorMessage.main'><ErrorMessage name='options' /></Typography>
                                <Typography fontSize="12px" color='errorMessage.main'><ErrorMessage name='correctAnswer' /></Typography>
                                <Typography fontSize="12px" color='errorMessage.main'><ErrorMessage name='answersStatus' /></Typography>
                                <Box marginTop="10px" border={border[1]} display="flex" gap="10px" flexDirection="column" borderRadius="5px">
                                    <Typography padding="20px 20px 0 20px" variant='subtitle1' gutterBottom fontWeight='500'>Add option</Typography>
                                    <Box padding="0 20px 20px 20px" display="flex" alignItems="flex-start" gap="10px" flexDirection="column">
                                        <Box bgcolor={palette.form.inputBg} color={palette.common.font} width="100%">
                                            <ReactQuill placeholder='Type the option text here...' className='custom-quill' modules={modules} value={optionAddedFieldValue} onChange={setOptionAddedFieldValue} />
                                        </Box>

                                        {/* {optionAddedFieldValue?.includes( "$" ) && <Box marginTop="10px" className='wysiwyg-text-container' width="calc(100% - 20px)" padding="10px" border={border[1]} borderRadius="10px">
                                                    <Latex delimiters={latexDelimiters} >{optionAddedFieldValue}</Latex>
                                                </Box>} */}

                                        <FormControlLabel sx={{ marginLeft: "0" }} labelPlacement='start' label="Correct answer?" control={<CustomSwitch color='primaryDark' checked={optionAdderSwitchState} onChange={e => setOptionAdderSwitchState( e.target.checked )} />} />
                                        <Button sx={{ background: "white", textTransform: "capitalize", '&:hover': { background: "white" } }} onClick={() => addOption( values.options, values.answersStatus, values.selectionType, setFieldValue )} variant="outlined" type="button" startIcon={Icons.default.AddIcon} >Add Option</Button>
                                    </Box>
                                </Box>
                                <Box marginTop="40px" display="flex" gap="10px" flexWrap="wrap">
                                    <Button type="submit" disabled={saving} color='success' startIcon={saving ? <CircularProgress size={14} /> : Icons.default.CheckIcon} sx={{ textTransform: "capitalize" }} variant="contained" disableElevation>Save question</Button>
                                    <Button disableElevation onClick={() => handleClose( resetForm )} sx={{ textTransform: "capitalize" }} variant="contained" color="error" >Close</Button>
                                </Box>
                            </Box>
                        </Form>
                    </Box>
                )
            }}
        </Formik>
    )
}

const EditQuestionDialog = observer( ( { question, title = "Edit question", state, setState, getQuestions } ) => {

    const [selectedLanguage, setSelectedLanguage] = useState( null )

    const { palette, border } = useTheme()

    const hasOptionsChangedRef = useRef()


    const handleClose = async () => {
        getQuestions()
        setState( false )
    }

    const translationsDetails = useMemo( () => {

        if ( !question.translations )
            return null

        const details = {}

        const languagesAvailable = Object.keys( question.translations )
        const defaultLang = languagesAvailable.find( lang => !Boolean( question.translations[lang] ) )

        details.default = defaultLang
        details.languages = languagesAvailable

        return details

    }, [question] )

    return (
        <Dialog
            slotProps={{
                paper: {
                    sx: { width: "90%", maxWidth: "950px", background: palette.form.formCardBg }
                }
            }}
            open={state}
        >

            <Box>
                <Box display="flex" justifyContent="space-between" gap="20px" alignItems="center" padding="20px">
                    <Typography variant="h6" fontSize="18px">{title}</Typography>
                    <IconButton onClick={handleClose} size="small">{Icons.default.CloseIcon}</IconButton>
                </Box>
                {translationsDetails && <Box padding="10px" borderRadius="5px" border={border[1]} bgcolor={palette.contentBg}>
                    <Typography gutterBottom variant='subtitle2' color='textSecondary'>Select language version to edit</Typography>
                    <Box display="flex" gap="5px" alignItems="center" flexWrap="wrap">
                        {translationsDetails.languages.map( lang => <CustomChip key={lang} onClick={() => setSelectedLanguage( lang === translationsDetails.default === lang ? null : lang )} value={lang} selected={lang === ( selectedLanguage || translationsDetails.default )} /> )}
                    </Box>
                </Box>}

                <EditForm getQuestions={getQuestions} handleClose={handleClose} key={selectedLanguage} selectedLanguage={selectedLanguage} question={question} hasOptionsChangedRef={hasOptionsChangedRef} />

            </Box>


        </Dialog>
    )
} )

export default EditQuestionDialog
